/**
 * Field Hub – Mobile Portal
 *
 * Purpose: Hub page for field ops with tabs (Units | Requests | Map | Activity).
 * Location: mobile-portal/src/pages/FieldHub.tsx
 */

import { useLocation, useNavigate } from 'react-router-dom';
import { PillGroup } from '@smartpay/ui';
import MobileUnits from './MobileUnits';
import Requests from './Requests';
import MapPage from './MapPage';
import Activity from './Activity';

const TABS: { path: string; label: string }[] = [
  { path: '/field/units', label: 'Units' },
  { path: '/field/requests', label: 'Requests' },
  { path: '/field/map', label: 'Map' },
  { path: '/field/activity', label: 'Activity' },
];

export default function FieldHub() {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const active = TABS.find((t) => t.path === pathname) ?? TABS[0];

  return (
    <div className="space-y-6">
      <PillGroup
        options={TABS.map((t) => ({ value: t.path, label: t.label }))}
        value={active.path}
        onChange={(path) => navigate(path)}
        variant="default"
        className="flex flex-wrap"
      />
      {pathname === '/field/units' && <MobileUnits />}
      {pathname === '/field/requests' && <Requests />}
      {pathname === '/field/map' && <MapPage />}
      {pathname === '/field/activity' && <Activity />}
    </div>
  );
}
